import Swal from "sweetalert2";
import SweetToast from "./SweetToast";

export function onFulfilled(response) {
  return response;
}

export function onRejected (error) {
  const { response } = error;

  if (!response) {
    return Promise.reject(error);
  }

  const { status, data } = response;
  const message = data?.message;

  if (
    // TODO: Wider task needed around specifically handling unauth'd errors
    // Consider taking control of laravel's unauthenticated message
    // Ideally though, we want to avoid string comparison
    (
        status === 401
        && message === 'Unauthenticated.'
    )
    || status === 419
  ) {
    Swal.fire({
      title: 'Session Timeout',
      html: 'Your session has timed out. Please refresh the page',
      icon: 'warning',
      confirmButtonText: 'Refresh',
      preConfirm() {
        location.reload();
      }
    });
    return;
  }

  return Promise.reject(error);
}
